module.exports = __webpack_public_path__ + "static/media/Illus-Empty_2.28eaf3c0.png";